module.exports = __webpack_public_path__ + "mainassets/img/main1.4510b401.jpg";